import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../utils/apiConfig";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      alert("Please enter email and password");
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/api/auth/login`, { 
        email, 
        password 
      });

      if (response.data.status) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("role", response.data.role);
        localStorage.setItem("user_id_PK", response.data.user_id_PK);
        localStorage.setItem("device_id", response.data.device_id);
        navigate("/homePage");
      } else {
        alert(response.data.message || "Invalid email or password");
      }
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || "Login failed - make sure your server is running");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-black selection:bg-green-500/30">
      {/* Dynamic Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-green-900/20 rounded-full blur-[120px]" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-green-900/20 rounded-full blur-[120px]" />
      </div>

      <div className="relative w-full max-w-md p-8">
        <div className="bg-[#1b1d1a]/80 backdrop-blur-xl rounded-2xl border border-white/5 shadow-[0_8px_32px_0_rgba(0,0,0,0.8)] p-8">
          <div className="text-center mb-8">
            <div className="relative inline-block mb-4">
              <div className="absolute inset-0 bg-green-500/20 rounded-full blur-xl scale-125" />
              <img
                src="/SVLogo.png"
                alt="Logo"
                className="relative h-20 w-20 mx-auto rounded-xl object-contain"
              />
            </div>
            <h2 className="text-3xl font-bold text-white tracking-tight">Welcome Back</h2>
            <p className="text-gray-400 mt-2 text-sm uppercase tracking-widest">Control Center Login</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <label className="text-xs font-semibold text-gray-400 uppercase tracking-wider ml-1">
                Email Address
              </label>
              <input
                type="email"
                placeholder="admin@gmail.com"
                className="w-full px-4 py-3 bg-black/40 border border-white/5 rounded-xl text-white placeholder:text-gray-600 focus:outline-none focus:ring-2 focus:ring-green-500/50 focus:border-green-500/50 transition-all duration-300"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="space-y-2">
              <label className="text-xs font-semibold text-gray-400 uppercase tracking-wider ml-1">
                Password
              </label>
              <input
                type="password"
                placeholder="••••••••"
                className="w-full px-4 py-3 bg-black/40 border border-white/5 rounded-xl text-white placeholder:text-gray-600 focus:outline-none focus:ring-2 focus:ring-green-500/50 focus:border-green-500/50 transition-all duration-300"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <div className="pt-2">
              <button
                type="submit"
                className="w-full py-4 bg-green-500 hover:bg-green-400 text-black font-bold rounded-xl transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] shadow-lg shadow-green-500/20"
              >
                Sign In
              </button>
            </div>
            
            <div className="text-center mt-4">
              <Link to="/forgot-password" className="text-green-500 hover:text-green-400 text-sm font-semibold transition-colors">
                Forgot Password?
              </Link>
            </div>
          </form>

          <div className="mt-8 text-center border-t border-white/5 pt-6">
            <p className="text-gray-500 text-xs">
              Smartshake Vending Management Module v1.0
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
